import { useFiltersContext } from '../hooks';
import { FiltersContextProvider, FiltersContextProviderProps } from '../providers';
import { DefaultFilters, OnRegisterChildren } from '../types/filter.types';

type FilterProviderProps<T> = FiltersProviderComponentProps<T> &
  Pick<FiltersContextProviderProps<T>, 'onChange' | 'cacheKey'>;

type FiltersProviderComponentProps<T> = {
  readonly children: OnRegisterChildren<T>;
  readonly value: T;
};

function FiltersProviderComponent<T>({ children }: Pick<FiltersProviderComponentProps<T>, 'children'>) {
  const { onRegister: register, filters } = useFiltersContext();

  return <div className="flex flex-wrap items-center gap-4 gap-y-2">{children(register, filters as T)}</div>;
}

export function FiltersProvider<T extends DefaultFilters = DefaultFilters>({
  children,
  ...props
}: FilterProviderProps<T>) {
  return (
    <FiltersContextProvider<T> {...props}>
      <FiltersProviderComponent>{children}</FiltersProviderComponent>
    </FiltersContextProvider>
  );
}
